"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    VISITOR_INSIGHTS_PAGE: [
        {
            entitlement: "B2B2024_PageVisitorInsights",
            // eventually remove below line to release to everyone with B2B2024_PageVisitorInsights entitlement
            launchDarkly: "dev-visitor-insights-v1",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
};
//# sourceMappingURL=visitor-insights.js.map